/** Broadcast when a request made while signed in returns 401, so the page can re-authenticate in place. */
type Listener = () => void;

const listeners = new Set<Listener>();

export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifySessionExpired(): void {
  for (const listener of listeners) listener();
}

/**
 * Batch 21 GRF-70: a sign-in from the session-expired dialog as a DIFFERENT person loads Home afresh instead of keeping the
 * page. An object so a test can replace it (jsdom cannot navigate).
 */
export const expiredSessionNavigation = {
  reloadHome: (): void => window.location.assign("/"),
};
